import { DOMAIN } from "../consts";
import trackUmamiEvent from "./umami";
import { getToken } from "./tokenStorage";

let requested = false;

const AD_TAG_KEY = "ad_tag";

// Рекламная метка юзера, пришедшего в бот по /start <tag>. Хранится в
// localStorage (может переживать сессии, если webview их сохраняет) и
// проставляется в аналитические события; в URL больше не пробрасывается.
export function getAdTag() {
  try {
    return localStorage.getItem(AD_TAG_KEY) || null;
  } catch {
    return null;
  }
}

function saveAdTag(tag) {
  try {
    localStorage.setItem(AD_TAG_KEY, tag);
  } catch {}
}

// Первое открытие миниаппа после перехода по рекламной метке: бэкенд атомарно
// помечает событие (ad_tag_events.opened_site) и отдаёт метку только один раз.
// Метку сохраняем в хранилище и сразу отправляем событие открытия в umami —
// атрибуция не зависит от utm-параметров в адресе страницы. Повторные вызовы
// безопасны: без пейденда метка вернётся null и ничего не произойдёт.
export default async function trackAdOpen() {
  if (requested) {
    return;
  }
  const token = getToken();
  if (!token) {
    return;
  }
  requested = true;
  try {
    const response = await fetch(DOMAIN + "/user/ad-tag/site-opened", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((r) => r.json());
    if (!response?.success || !response.tag) {
      return;
    }
    saveAdTag(response.tag);
    trackUmamiEvent("Miniapp opened", {
      utm_source: "tg_ads",
      utm_campaign: response.tag,
    });
  } catch {
    // сеть упала до ответа бэкенда — метка не потрачена, попробуем в следующий заход
    requested = false;
  }
}
